angular.module('jv.login.service', ['App.ajax.service'])
    .factory('jvLoginServiceConstant', [function() {
        return {
            Urls: {
                'login': '/login/action/performLogin',
                'sendPasswordLink': '/login/action/sendPasswordLink',
                'resetPassword': '/login/action/resetPassword',
                'disconnectSocialAccount': '/login/action/disconnectApp'
            }
        };
    }])
    .service('jvLoginService', ['$window', '$q', 'makeAjaxCall', 'jvLoginServiceConstant',
        function($window, $q, makeAjaxCall, jvLoginServiceConstant) {
            var loginService = {};
            /**
             *  Utility for calling the ajax functions.
            */
            function createRequestObject(args, callback, options) {
                callback = (callback || angular.noop);
                var requestObj = args || {};
                requestObj.ajaxtype = options.ajaxtype;
                requestObj.url = options.url;
                requestObj.requestType = options.requestType || 'GET';
                requestObj.cache = options.cache || false;
                var requestPromise = makeAjaxCall(requestObj);
                return requestPromise.then(function(results) {
                    callback(results);
                    return results;
                }, function(results) {
                    callback(results);
                });
            }

            // For POST-ing the user workflow
            loginService.login = function(args, callback) {
                var options = {
                    'ajaxtype': 'login',
                    'url': jvLoginServiceConstant.Urls.login,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            loginService.sendPasswordLink = function(args, callback) {
                var options = {
                    'ajaxtype': 'sendPasswordLink',
                    'url': jvLoginServiceConstant.Urls.sendPasswordLink,
                    'requestType': 'POST'
                };
                createRequestObject(args, callback, options);
            };

            loginService.resetPassword = function(args, callback) {
                var options = {
                    'ajaxtype': 'resetPassword',
                    'url': jvLoginServiceConstant.Urls.resetPassword,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            loginService.disconnectSocialAccount = function(args, callback) {
                var options = {
                    'ajaxtype': 'disconnectSocialAccount',
                    'url': jvLoginServiceConstant.Urls.disconnectSocialAccount,
                    'requestType': 'POST'
                };
                args.headers = {'Content-Type': 'application/json; charset=UTF-8'};
                createRequestObject(args, callback, options);
            };

            return loginService;

}]);
